// jquery
$(document).ready(() => {
  const isRTL = $('#content-wrapper').attr('dir') === 'rtl';
  $('#oc-container .carousel').each((key, item) => {
    const $item = $(item);
    const id = $item.attr('id');

    let filtered = false;
    const $progressBar = $(`#${id} .carousel__progress > div`);

    let intersecting = false;
    $item.observe(
      (evt) => {
        if (evt[0].isIntersecting) {
          intersecting = true;
        } else {
          intersecting = false;
        }
      },
      { threshold: 0 }
    );

    const checkBreakpoint = () => {
      if (window.innerWidth >= 768 && !filtered) {
        $(`#${id} .carousel__list`).slick('slickFilter', ':not(.placeholder)');
        filtered = true;
      } else if (window.innerWidth < 768 && filtered) {
        $(`#${id} .carousel__list`).slick('slickUnfilter');
        filtered = false;
      }
    };

    let swiped = false;
    $(`#${id} .carousel__list`).on('init', (e, slick) => {
      setTimeout(() => {
        checkBreakpoint();
        if (!swiped) {
          slick.$slider.append(`
            <div class="scroll-indicator-container" aria-hidden="true" tabindex="-1">
              <div class="scroll-indicator" />
            </div>
          `);
        }
      }, 0);
    });

    $(`#${id} .carousel__list`).on(
      'beforeChange',
      (event, slick, currentSlide, nextSlide) => {
        if (intersecting && nextSlide !== currentSlide) {
          window.handleImpressionTracking($(slick.$slides[nextSlide]));
        }

        const progress = 100 - (nextSlide / (slick.slideCount - 1)) * 100;
        $progressBar.css(
          'transform',
          `translateX(${isRTL ? '' : '-'}${progress}%)`
        );
        const $nextSlide = $(slick.$slides[nextSlide]);
        const $currentSlide = $(slick.$slides[currentSlide]);
        if ($nextSlide.hasClass('placeholder')) {
          $nextSlide.prev().addClass('placeholder-current');
        }
        if ($currentSlide.hasClass('placeholder')) {
          $currentSlide.prev().removeClass('placeholder-current');
        }
      }
    );

    $(`#${id} .carousel__list`).on('swipe', () => {
      if (!swiped) {
        swiped = true;
        const indicators = $('.scroll-indicator-container');
        indicators.fadeOut(300, () => {
          indicators.remove();
        });
      }
    });

    $(window).on('resize', checkBreakpoint);

    // init slick
    $(`#${id} .carousel__list`).slick({
      arrows: false,
      infinite: false,
      variableWidth: true,
      mobileFirst: true,
      centerMode: true,
      rtl: isRTL,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true,
            prevArrow: `#${id} .carousel__prev`,
            nextArrow: `#${id} .carousel__next`,
          },
        },
      ],
    });
  });
});
